import React from 'react';
import { MapPin, Phone, Clock, Mail, Instagram, Facebook, Twitter } from 'lucide-react';
import ContactForm from './ContactForm';

const Contact = () => {
  const contactInfo = [
    {
      icon: <MapPin className="h-5 w-5 sm:h-6 sm:w-6 text-red-500" />,
      title: 'Location',
      details: ['41 Dravus Street', 'Seattle, WA 98109']
    },
    {
      icon: <Phone className="h-5 w-5 sm:h-6 sm:w-6 text-green-500" />,
      title: 'Phone',
      details: ['(206) 492-7765', 'For Orders & Info']
    },
    {
      icon: <Clock className="h-5 w-5 sm:h-6 sm:w-6 text-blue-500" />,
      title: 'Hours',
      details: ['Every Day: 11am-10pm', 'Open 7 Days a Week']
    },
    {
      icon: <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-yellow-500" />,
      title: 'Email',
      details: ['hotslicepizzaseattle@gmail.com', 'We\'d love to hear from you!']
    }
  ];

  const socialLinks = [
    { icon: <Instagram className="h-5 w-5 sm:h-6 sm:w-6" />, name: 'Instagram', href: '#' },
    { icon: <Facebook className="h-5 w-5 sm:h-6 sm:w-6" />, name: 'Facebook', href: '#' },
    { icon: <Twitter className="h-5 w-5 sm:h-6 sm:w-6" />, name: 'Twitter', href: '#' }
  ];

  return (
    <section id="contact" className="py-12 sm:py-20 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Visit <span className="text-red-600">Us</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto">
            Come experience authentic NY style flavors in the heart of Seattle. 
            We can't wait to serve you!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12">
          {/* Contact Information */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 sm:mb-8">Get in Touch</h3>
            
            <div className="space-y-6 sm:space-y-8">
              {contactInfo.map((item, index) => (
                <div key={index} className="flex items-start space-x-3 sm:space-x-4">
                  <div className="flex-shrink-0 bg-gray-800 p-2 sm:p-3 rounded-xl">
                    {item.icon}
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-semibold text-white mb-1 sm:mb-2">{item.title}</h4>
                    {item.details.map((detail, idx) => (
                      <p key={idx} className="text-gray-300 text-sm sm:text-base">{detail}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Social Links */}
            <div className="mt-8 sm:mt-12">
              <h4 className="text-base sm:text-lg font-semibold text-white mb-4">Follow Us</h4>
              <div className="flex space-x-3 sm:space-x-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="bg-gray-800 hover:bg-red-600 p-2 sm:p-3 rounded-xl transition-colors duration-200 text-gray-300 hover:text-white"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <ContactForm />
          </div>

          {/* Location Map */}
          <div className="bg-gray-800 rounded-2xl p-4 sm:p-8">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6">Find Us</h3>
            
            {/* Google Maps Embed */}
            <div className="rounded-xl overflow-hidden h-48 sm:h-64 mb-4 sm:mb-6 shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2687.4!2d-122.3654!3d47.6399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54901507c8b8c8c8%3A0x1234567890abcdef!2s41%20Dravus%20St%2C%20Seattle%2C%20WA%2098109!5e0!3m2!1sen!2sus!4v1704067200000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Hot Slice Pizza Location"
                className="w-full h-full"
              ></iframe>
            </div>
            
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-center justify-between text-gray-300 text-sm sm:text-base">
                <span>Pickup Available</span>
                <span className="text-green-400 font-semibold">✓ Yes</span>
              </div>
              <div className="flex items-center justify-between text-gray-300 text-sm sm:text-base">
                <span>Delivery Available</span>
                <span className="text-yellow-400 font-semibold">Coming Soon</span>
              </div>
              <div className="flex items-center justify-between text-gray-300 text-sm sm:text-base">
                <span>Parking</span>
                <span className="text-green-400 font-semibold">✓ Street Parking</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;